/* eslint-disable no-undef */

export function setNotificationsUnreadCount(notifications, context) {
    const notificationsLink = context.querySelector(
        '#top-bar_notifications-link',
    );
    const notificationsBubble = context.querySelector(
        '#top-bar_notifications-count-bubble',
    );

    if (
        notifications &&
        (notifications.hasNotifications || notifications.count > 0)
    ) {
        // Until new old notification center is turned off and gone we need to keep this for backwards compatibility
        if (notifications.count > 0) {
            notificationsLink.setAttribute(
                'aria-label',
                `Varslinger (${notifications})`,
            );
        } else {
            notificationsLink.setAttribute('aria-label', `Varslinger (nye)`);
        }
        notificationsBubble.innerHTML = `<span id="notifications-bubble" style="background-color: #FF5844;" class="absolute sm:right-auto sm:mr-16 md:left-20 md:ml-4 top-12 rounded-full w-12 h-12 border-2 border-white" />`;
    } else {
        notificationsLink.setAttribute('aria-label', `Varslinger`);
        notificationsBubble.innerHTML = ``;
    }
}

export function storeNotificationsUnreadCount(count) {
    const store = window.sessionStorage;
    if (count && count !== '0') {
        store.setItem('notificationsUnreadCount', count);
    } else {
        store.removeItem('notificationsUnreadCount');
    }
}

export function storeMessagesUnreadCount(count) {
    const store = window.sessionStorage;
    if (count && count !== '0') {
        store.setItem('messagesUnreadCount', count);
    } else {
        store.removeItem('messagesUnreadCount');
    }
}

export function storeProfileImage(url) {
    const store = window.sessionStorage;
    if (url) {
        store.setItem('profileImageURL', url);
    } else {
        store.removeItem('profileImageURL');
    }
}

function setOrReplaceTitleCount(count) {
    const { title } = window.document;
    const match = title.match(/(\(.*\))\s/);
    if (match) window.document.title = title.replace(match[1], `(${count})`);
    else window.document.title = `(${count}) ${title}`;
}

export function setMessagesUnreadCount(count, context) {
    const messagesLink = context.querySelector('#top-bar_messages-link');
    const messagesBubble = context.querySelector(
        '#top-bar_messages-count-bubble',
    );
    if (count && count !== '0') {
        setOrReplaceTitleCount(count);
        messagesLink.setAttribute('aria-label', `Meldinger (${count})`);
        messagesBubble.innerHTML = `<span id="messages-bubble" style="background-color: #FF5844;" class="absolute sm:right-auto sm:mr-16 md:left-20 md:ml-8 top-12 rounded-full w-12 h-12 border-2 border-white" />`;
    } else {
        window.document.title = window.document.title.replace(/\(.*\)\s/, '');
        messagesLink.setAttribute('aria-label', `Meldinger`);
        messagesBubble.innerHTML = ``;
    }
}

export function setProfileImage(url, context) {
    const profileSpace = context.querySelector('#topbar_profile-image');

    if (url) {
        profileSpace.innerHTML = `<img src="${url}" class="top-bar__menu-item__profile-picture rounded-full" alt="Mitt profilbilde" width="28" height="28" >`;
    } else {
        // TODO: set the profile image back to the default
        // this requires passing the image to the client somehow
    }
}
